import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import { Column, Row } from 'src/components/Layout/Styled'
import EnrollInfoItem from './EnrollInfoItem'

const EnrollInfo = () => {
  const { enroll } = useSelector(
    (state) => ({
      enroll: state.classEnroll.enroll,
    }),
    shallowEqual
  )
  return (
    <Column sx={{ background: '#FAFAFA', mb: 2, p: 3, rowGap: 2 }}>
      <Row>
        <GroupsOutlinedIcon sx={{ mr: 1, fontSzie: 24, color: '#00008F' }} />
        <Typography variant="h6" color="primary.main">
          {`อัปเดทข้อมูล และอัปโหลดเอกสาร`}
        </Typography>
      </Row>
      {enroll.map((ele, ind) => {
        return <EnrollInfoItem key={ind} index={ind} />
      })}
    </Column>
  )
}

export default EnrollInfo
